import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import AdminLogin from './components/AdminLogin';
import AccountLookup from './pages/AccountLookup';
import ReportQueue from './pages/ReportQueue';
import ShardHealth from './pages/ShardHealth';
import StripeDeadLetter from './pages/StripeDeadLetter';
import AuditLog from './pages/AuditLog';
import AuditLogLive from './pages/AuditLogLive';
import WelcomeBackStats from './pages/WelcomeBackStats';
import AbuseSignals from './pages/AbuseSignals';
import { RoleProvider } from './auth/role-context';

function getToken(): string | null {
  return localStorage.getItem('admin_token');
}

function RequireAuth({ children }: { children: React.ReactNode }) {
  if (!getToken()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<AdminLogin />} />

      {/* Protected routes — wrapped in RoleProvider so every page can useRole() */}
      <Route
        path="/*"
        element={
          <RequireAuth>
            <RoleProvider>
              <div className="layout">
                <Header />
                <div className="page-content">
                  <Routes>
                    <Route index element={<Navigate to="/accounts" replace />} />
                    <Route path="accounts" element={<AccountLookup />} />
                    <Route path="reports" element={<ReportQueue />} />
                    <Route path="shard-health" element={<ShardHealth />} />
                    <Route path="stripe-dead-letter" element={<StripeDeadLetter />} />
                    <Route path="audit-log" element={<AuditLog />} />
                    <Route path="audit-log/live" element={<AuditLogLive />} />
                    <Route path="welcome-back" element={<WelcomeBackStats />} />
                    <Route path="abuse-signals" element={<AbuseSignals />} />
                    <Route path="*" element={<Navigate to="/accounts" replace />} />
                  </Routes>
                </div>
              </div>
            </RoleProvider>
          </RequireAuth>
        }
      />
    </Routes>
  );
}
